import  {useEffect, useState} from 'react';
import AIheader from '../RentAI/AIheader'
import Footer from '../../Component/Footer/Footer';
import './BlogsPage.css';
//import { Category } from '@mui/icons-material';

const BlogsPage = () => {

const [posts, setPosts] = useState([]);



useEffect(() => {
  fetch("https://cms.rentid.io/api/blog-templates?populate[banner_section][populate]=*", {
  method: 'GET', // or 'POST', 'PUT', etc.
  headers: {
    'Authorization': process.env.REACT_APP_CMS_KEY,
    'Content-Type': 'application/json' // if sending or receiving JSON
  }
})
    .then((res) => res.json())
    .then((data) => {
      if (data?.data) {
        const formattedPosts = data.data.map((post) => {
          // Find the banner image component
          const bannerImageComponent = post.banner_section?.find(
            (section) => section.__component === "banner.banner-image"
          );

          const imageUrl = bannerImageComponent?.banner_image?.url
            ? `https://cms.rentid.io${bannerImageComponent.banner_image.url}`
            : null;

          return {
            id: post.id,
            title: post.blog_titile || "No Title",
            description: post.Excerpt || "No Description",
            imageUrl,
            published_date: post.publishedAt,
            slug: post.slug,
            category: post.category,
            //blog_description: post.blog_description
          };
        });

        setPosts(formattedPosts);
      }
    })
    .catch((err) => console.error("Error fetching data:", err));
}, []);




      const recentPost = posts.length > 0 
      ? [...posts].sort((a, b) => new Date(b.published_date) - new Date(a.published_date))[0] 
      : null;
    
    console.log(recentPost, 'dfnd');
    

    return (
        <>
<AIheader/>

{/* START bannerBlogMain */}
<section className="bannerBlogMain">
    <div className="bannerBlogOuter">
        <div className="container">
        <div className="row">
  {posts.length > 0 && (
    <div className="col-lg-12">
      <div className="bannerBlogInner">
        <div id="demo" className="carousel slide" data-bs-ride="carousel">
          
          {/* Carousel Indicators */}
          <div className="carousel-indicators">
            {posts.slice(0, 3).map((_, index) => (
              <button
                key={index}
                type="button"
                data-bs-target="#demo"
                data-bs-slide-to={index}
                className={index === 0 ? "active" : ""}
              />
            ))}
          </div>

          {/* Carousel Items */}
          <div className="carousel-inner">
            {posts.slice(0, 3).map((post, index) => (
              <div
                key={post.id}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
              >
                
                {/* <img className="imgBanner" src="/img/blog/blog_banner_1.png"  alt="rent id" /> */}
                <img className="imgBanner" src={post.imageUrl} alt="rent id" />
                <div className="carousel-caption">
                  <div className="blogHeading">
                    <img width="17px" src="/img/blog/blog_icon.svg" alt="icon" />
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item active" aria-current="page">Blog</li>
                    </ol>
                  </div>
                  <h1>{post.title}</h1>
                  {/* <p>{post.blog_description.length > 180 ? post.blog_description.substring(0, 180) + '...' : post.blog_description}</p> */}
                  <a href={`/blog/${post.slug}`} className="btn btnTransparent_3">
                    Read more 
                    <img width="24px" src="/img/blog/arrow-right-btn.svg" alt="icon"/>
                  </a>
                </div>
              </div>
            ))}
          </div>

          {/* Carousel Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#demo"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon"></span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#demo"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon"></span>
          </button>
        </div>
      </div>
    </div>
  )}
</div>
        </div>
    </div>
</section>
{/* END bannerBlogMain */}





{/* START recentBlogMain */}
<section className="recentBlogMain">
    <div className="container">
        <div className="recentBlogTop">
            <div className="row">
                <div className="col-lg-12">
                    <div className="headRecentBlog">
                        <h2>Most recent</h2>
                    </div>
                </div>
            </div>
            <div className='recentBlogOuter'>
            {recentPost && (
             <a href={`/blog/${recentPost.slug}`}>
                <div className='row align-items-center'>
                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                        <div className='recentBlogLeft'>
                            <figure>
                                <img className="img-fluid" src={recentPost.imageUrl}  alt="blog" />
                            </figure>
                        </div>
                    </div>
                    <div className='col-lg-6 col-md-12 col-sm-12 col-12'>
                        <div className='recentBlogRight'>
                        <h2>{recentPost.title}</h2>
                            {/* <h2>Thanks, <span class="pinkSpan">Marketplaces</span>. We’ll Take It From Here.</h2> */}
                            {/* <p>{recentPost.blog_description}</p> */}
                            <div className='recentBlogRightBtn'>
                                <a href='/market-place'>4 mins read</a>
                            </div>
                            <small>
                            Published{" "}
                            {new Date(recentPost.published_date).toLocaleDateString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric"
                            })}
                            </small>

                        </div>
                    </div>
                </div>
               
            </a>
             )}
            </div>
        </div>
    </div>
</section>
{/* END recentBlogMain */}


{/* START blogMain */}
<section className="blogMain">
	<div className="container">
        <div className="recentBlogTop">
            <div className="row">
                <div className="col-lg-12">
                    <div className="headBlog">
                        <h2>How-To Guides</h2>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-6">  
                    <div className="blogInner">
                        <a href="/maximum-booking">
                        <figure>
                            <img className="img-fluid" src="/img/blog/guide_1.png"  alt="blog" />
                        </figure>
                        <div className="blogData">
                            <h3>How to Optimize Your Vehicle Listing for Maximum Bookings</h3>
                            <p>In the world of car rental platforms, standing out is key to ensuring your vehicle gets noticed and booked by potential renters.</p>
                            <span>Published 2/28/25</span>
                        </div> 
                        </a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6">  
                    <div className="blogInner">
                        <a href="/identity-verification">
                        <figure>
                            <img className="img-fluid" src="/img/blog/guide_2.png"  alt="blog" />
                        </figure>
                        <div className="blogData">
                            <h3>The Importance of Identity Verification in Car Rentals</h3>
                            <p>In the fast-paced world of car rentals, ensuring the safety and security of both the business and 
                            its customers is of utmost importance. Identity verification is a crucial component in achieving this goal, 
                            serving as the first line of defense against fraud, unauthorized access, and potential liabilities.</p>
                            <span>Published 2/26/25</span>
                        </div> 
                        </a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6">  
                    <div className="blogInner">
                        <a href="/market-place">
                            <figure>
                                <img className="img-fluid" src="/img/blog/guide_4.png"  alt="blog" />
                            </figure>
                            <div className="blogData">
                                <h3>The Unfortunate Fall of GetAround and HyreCar: What’s Next for Fleet Operators?</h3>
                                <p>For thousands of fleet operators and car-sharing hosts, the recent shutdown of Getaround and HyreCar is more than just industry news—it’s deeply personal. It represents lost income, broken trust, and an uncertain future for hardworking individuals who built their businesses on these platforms. As the dust settles, one pressing question remains: What’s next?</p>
                                <span>Published 3/04/25</span>
                            </div> 
                        </a>
                    </div>
                </div>
            </div>
		</div>

	</div>
</section>
{/* END blogMain */}




{/* START blogMain */}
<section className="blogMain">
      {posts.length > 0 && (
        <div className="container">
          <div className="recentBlogTop">
            <div className="row">
              <div className="col-lg-12">
                <div className="headBlog">
                  <h2>Rentdirect</h2>
                </div>
              </div>
            </div>

            <div className="row">
              {/* Map over the posts and filter by category */}
              {posts
                .filter(post => post.category === 'RentDirect') // Only show posts with category 'Rentshield'
                .map(post => (
                  <div className="col-lg-4 col-md-6 col-sm-6" key={post.id}>
                    <div className="blogInner">
                      <a href={`/blog/${post.slug}`}>
                        <figure>
                          <img
                            className="img-fluid"
                            src={post.imageUrl} // Assuming the image is named according to the slug
                            alt="blog"
                          />
                        </figure>
                        <div className="blogData">
                          <h3>{post.title}</h3>
                          {/* <p>{post.blog_description}</p> */}
                          
                          {/* Accessing the first element in body_content for published_date */}
                          {post.body_content && post.body_content.length > 0 && (
                            <span>
                              Published {new Date(post.body_content[0].published_date).toLocaleDateString()}
                            </span>
                          )}
                        </div>
                      </a>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </section>
{/* END blogMain */}

<Footer/>
        </>
    )
}

export default BlogsPage;